module.exports = __webpack_public_path__ + "img/portuguese.939aca55.png";